import { ref, Ref } from 'vue';
import { useRoute } from 'vue-router';
import { Credentials } from '@/interfaces/credentials.interface';
import { LoginValidation } from '@/interfaces/login-validation.interface';
import { CxServiceUnavailableError } from '@/classes/error.class';
import loginApi from '@/http/login.api';

export default function useSilentLogin() {
  const route = useRoute();

  // Data
  const isSilentLoginInProgress: Ref<boolean> = ref(true);
  const isSilentRedirectInProgress: Ref<boolean> = ref(false);
  const silentCredentials: Ref<Credentials> = ref({
    username: '',
    password: '',
    rememberMe: false
  });

  // Methods
  const redirectToConX = (overridePath?: string): void => {
    if (overridePath) {
      window.location.replace(overridePath);
      return;
    }

    const path = route.query.next ? decodeURIComponent(`#${route.query.next}`) : '';
    window.location.replace(process.env.VUE_APP_CONX_UI_LOCATION + path);
  };

  const silentLogin = async (errorCallback: Function): Promise<void> => {
    let result: LoginValidation = { loggedIn: false };
    try {
      result = await loginApi.logIn(silentCredentials.value);
      if (result.loggedIn) {
        isSilentRedirectInProgress.value = true;
        redirectToConX(result.redirectUrl);
      }
    } catch (error) {
      if (error instanceof CxServiceUnavailableError) errorCallback();
    } finally {
      isSilentLoginInProgress.value = false;
    }
  };

  // Expose properties and methods
  return {
    // Data
    isSilentLoginInProgress,
    isSilentRedirectInProgress,
    // Methods
    redirectToConX,
    silentLogin
  };
}
